<div class="container-fluid">
  <div class="row">
    <div class="col-60">
      <div class="d-flex flex-row justify-content-center w-100 py-3 mt-2 py-md-5 flex-wrap">
        <div class="px-3">
          <a title="Elsa srl" appEmptyTitle (click)="shuffleInstance.filter(Shuffle.ALL_ITEMS)" class="text-uppercase elsa-title-font category-item"
             [ngClass]="{'active': !shuffleInstance || (shuffleInstance.lastFilter === Shuffle.ALL_ITEMS)}">{{'label_all' | translate}}</a>
        </div>
        <div class="px-3" *ngFor="let item of categories">
          <a [title]="item.title" appEmptyTitle (click)="shuffleInstance.filter(item.title_slug)" class="text-uppercase elsa-title-font category-item"
             [ngClass]="{'active': shuffleInstance?.lastFilter === item.title_slug}">{{item.title}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="row bg-shuffle-container"  #shuffleContainer>
    <!--    [attr.data-groups]='[img.category.title_slug]'-->
    <figure class="col-20 col-md-15 col-lg-10 picture-item px-0" *ngFor="let img of items"
            [attr.data-groups]='img.category ? "[\""+img.category.title_slug+"\"]" : "[]"'>
      <div class="aspect aspect--16x9">
        <div class="aspect__inner">
          <picture>
            <source media="(max-width: 767px)"
                    [srcset]="img.file.path">
            <source media="(min-width: 992px)"
                    [srcset]="img.file.path">
            <img [src]="img.file.path"
                 [alt]="img.title" class="img-fluid img-blank-and-white w-100 object-fit-cover h-100">
          </picture>
        </div>
      </div>
    </figure>
    <div class="col-20 col-md-15 col-lg-10 p-0 m-0" #shuffleSizer></div>
  </div>
</div>
